export { SortArrayPipeModule } from './sort-array.pipe.module';
export { SortArrayPipe } from './sort-array.pipe';
